export default __webpack_public_path__ + "static/media/githubIcon.bad53d1d.png";